import React from 'react'
import { useField } from 'formik'

// Returns true if the argument is an event
// Copied from https://github.com/erikras/redux-form/blob/master/src/events/isEvent.js

function isEvent(value) {
  return !!(value && value.stopPropagation && value.preventDefault)
}

function composeEventHandlers(
  fieldName,
  customEventHandler,
  defaultEventHandler
) {
  return function onEvent(value) {
    // Create a fake event if necessary since formik expects an event object
    const changeEvent = isEvent(value)
      ? value
      : { target: { name: fieldName, value } }
    defaultEventHandler(changeEvent)
    // Call custom event handler
    if (customEventHandler) customEventHandler(changeEvent)
  }
}

function wrapDisplayName(BaseComponent, hocName) {
  return `${hocName}(${
    BaseComponent.displayName || BaseComponent.name || 'Component'
  })`
}

// Adapts a redux-form input to use formik instead by passing the correct props.
function withFormikAdapter() {
  return (InputComponent) => {
    function WrappedInputComponent({ onChange, onBlur, name, ...rest }) {
      const [field, meta] = useField({ name, ...rest })
      return (
        <InputComponent
          input={{
            name: field.name,
            value: field.value,
            onChange: composeEventHandlers(
              field.name,
              onChange,
              field.onChange
            ),
            onBlur: composeEventHandlers(field.name, onBlur, field.onBlur),
          }}
          meta={{
            error: meta.error,
            touched: meta.touched,
            invalid: !!meta.error,
          }}
          {...rest}
        />
      )
    }
    WrappedInputComponent.displayName = wrapDisplayName(
      InputComponent,
      'withFormikAdapter'
    )
    return WrappedInputComponent
  }
}

export default withFormikAdapter
